import React from 'react';
import { Typography } from '@material-ui/core';


const CouponRuleSummary = ({values, categories, products, customerGroups, buyXgetYActions}) => {
  const selectedCategoriesList = (operator) => {
    const {value} = values.action_condition.conditions.find((cond) => (
      cond.attribute_name === 'category_ids' && cond.operator === operator
    ));
    const categoryIds = value.split(', ');
    const selectedCategoriesNames = categories.reduce((acc, c) => {
      if (categoryIds.includes(String(c.id))) {
        acc.push(c.name);
      }

      return acc;
    }, []);

    return selectedCategoriesNames.length ? selectedCategoriesNames.join(', ') : '';
  };

  const selectedProductsList = (operator) => {
    let skuValues;

    if (operator === 'bundle') {
      skuValues = values.promo_skus.split(', ');
    } else {
      const { value } = values.action_condition.conditions.find((cond) => (
        cond.attribute_name === 'sku' && cond.operator === operator
      ));
      skuValues = value.split(', ');
    }

    const selectedProductsNames = products.reduce((acc, product) => {
      if (skuValues.includes(String(product.sku))) {
        acc.push(product.name);
      }

      return acc;
    }, []);

    return selectedProductsNames.length ? selectedProductsNames.join(', ') : '';
  };

  const selectedCustomerGroups = () => {
    const selectedGroupsNames = customerGroups
      .filter((g) => (
        values.customer_group_ids.includes(Number(g.id))
      ))
      .map((g) => g.code);
    return selectedGroupsNames.join(', ');
  };

  const minimumOrder = (attributeName) => {
    const { value } = values.action_condition.conditions.find((cond) => (
      cond.attribute_name === attributeName && cond.operator === '>='
    ));
    return value;
  };


  return (
    <>
      <Typography variant="h5" className="font-bold mb-3 uppercase">
        Summary
      </Typography>
      {!!values.name.length &&
        <ul className="pl-5 text-13">
          <li className="mb-1">
            <span>Coupon Code: </span>
            <span>{values.coupon_code?.code}</span>
          </li>
          <li className="mb-1">
            <span>Title: </span>
            <span>{values.name}</span>
          </li>
          <li className="mb-1">
            <span>Description: </span>
            <span>{values.description}</span>
          </li>
          <li className="mb-1">
            <span>Uses per Coupon: </span>
            <span>{values.uses_per_coupon}</span>
          </li>
          <li className="mb-1">
            <span>Uses per Customer: </span>
            <span>{values.uses_per_customer}</span>
          </li>
          {values.discount_amount !== '' &&
            <li>
              {values.simple_action === 'eachn_perc' &&
                <span>{values.discount_amount}{'%'} OFF </span>
              }
              {values.simple_action === 'eachn_fixprice' &&
                <span>{'$'}{values.discount_amount} Fixed Price </span>
              }
              {values.simple_action === 'setof_percent' &&
                <span>{values.discount_amount}{'%'} OFF </span>
              }
              {values.simple_action === 'setof_fixed' &&
                <span>{values.discount_amount}{'$'} Fixed price </span>
              }
              {buyXgetYActions?.includes(values.simple_action) &&
              <span>
                {`Buy ${values.discount_step}X`}
                {` Get ${values.nqty}Y `}
                {values?.discount_amount &&
                  <>
                    <br />
                    {` Discount Amount: ${values.discount_amount}${values.simple_action === 'buyxgetn_perc' ? '%' : '$'}`}
                    <br />
                  </>
                }
              </span>
              }
              {
                ['setof_percent', 'setof_fixed'].includes(values.simple_action) && values.promo_skus.length &&
                <span>
                  {selectedProductsList('bundle')}
                </span>
              }
              {values.simple_action === 'by_percent' &&
                <span>{values.discount_amount}{'%'} OFF </span>
              }
              {values.simple_action === 'by_fixed' &&
                <span>{values.discount_amount}{'$'} OFF for each item </span>
              }
              {values.simple_action === 'cart_fixed' &&
                <span>{values.discount_amount}{'$'} OFF for whole cart </span>
              }
              {!values.action_condition?.conditions.length && !['setof_percent', 'setof_fixed'].includes(values.simple_action) &&
              <span>Storewide</span>
              }
              {values.action_condition?.conditions.find((cond) => cond.value === 'PROD') &&
              <span>All Products</span>
              }
              {values.action_condition?.conditions.find((cond) => cond.value === 'TREAT') &&
              <span>All Treatments</span>
              }
              {values.action_condition?.conditions.find((cond) => (
                cond.attribute_name === 'category_ids'
                 && cond.operator === '()'
                 && !!cond.value.length
              )) &&
              <span>
                {selectedCategoriesList('()')}
              </span>
              }
              {values.action_condition?.conditions.find((cond) => (
                cond.attribute_name === 'sku'
                 && cond.operator === '()'
                 && !!cond.value.length
              )) &&
              <span>
                {selectedProductsList('()')}
              </span>
              }
              {values.action_condition?.conditions.find((cond) => (
                (cond.attribute_name === 'category_ids'
                 || cond.attribute_name === 'sku')
                 && cond.operator === '!()'
                 && !!cond.value.length
              )) &&
              <span> except </span>
              }
              {values.action_condition?.conditions.find((cond) => (
                cond.attribute_name === 'category_ids'
                 && cond.operator === '!()'
                 && !!cond.value.length
              )) &&
              <span>
                {selectedCategoriesList('!()')}
              </span>
              }
              {values.action_condition?.conditions.find((cond) => (
                cond.attribute_name === 'sku'
                 && cond.operator === '!()'
                 && !!cond.value.length
              )) &&
              <span>
                {selectedProductsList('!()')}
              </span>
              }
            </li>
          }
          {values?.max_discount && (
            <li className="mb-1">
              <span>Maximum Amount of discount: {values.max_discount}</span>
            </li>
          )}
          {values?.discount_qty && (
            <li className="mb-1">
              <span>Maximum quantity allowed to receive the discount: {values.discount_qty}</span>
            </li>
          )}
          {values.simple_free_shipping != '0' &&
            <li className="mb-1">
              <span>Allows Free Shipping</span>
            </li>
          }
          {values.customer_group_ids.length != '0' &&
          values.customer_group_ids.length != customerGroups.length &&
          <li className="mb-1">
            <span>For customers in </span>
            <span>{selectedCustomerGroups()} group</span>
          </li>
          }
          {values.customer_group_ids.length === customerGroups.length &&
          <li className="mb-1">
            <span>For All Customers </span>
          </li>
          }
          {values.action_condition?.conditions.find((cond) => (
            cond.attribute_name === 'quote_item_qty'
            && cond.operator === '>='
            && !!cond.value.length
          )) &&
            <li className="mb-1">
              <span>Quantity of order: </span>
              <span> {minimumOrder('quote_item_qty')}</span>
            </li>
          }
          {values.action_condition?.conditions.find((cond) => (
            cond.attribute_name === 'quote_item_row_total'
            && cond.operator === '>='
            && !!cond.value.length
          )) &&
            <li className="mb-1">
              <span>Purchase Amount: $</span>
              <span> {minimumOrder('quote_item_row_total')}</span>
            </li>
          }
          {!!values.from_date &&
            <li className="mb-1">
              <span>Start Date: </span>
              <span>{values.from_date}</span>
            </li>
          }
          {values.allowEndDate && values.to_date &&
            <li className="mb-1">
              <span>End Date: </span>
              <span>{values.to_date}</span>
            </li>
          }
        </ul>
      }
    </>
  );
};

export default CouponRuleSummary;
